var link_preview_default = {
  "fontElementMap": "R1vDv",
  "linkPreviewContainer": "hy46Z",
  "linkPreview": "SYwic",
  "linkPreviewImage": "hhDXU",
  "linkPreviewPlaceholder": "RGVsY",
  "linkPreviewInfo": "VO98D",
  "linkPreviewTitle": "E7-Ki",
  "linkPreviewDescription": "DNM11",
  "linkPreviewUrl": "Bmd-S",
  "linkPreviewResponsiveImage": "D6viO",
  "loadingContainer": "nv3-r",
  "errorIcon": "_9kjI8",
  "errorInfo": "E0qAW",
  "errorContainer": "Je19h",
  "overlay": "I-5Sk",
  "thumbnailEnd": "vX3ep",
  "thumbnailStart": "ZtmRg",
  "thumbnailTop": "rwG7V"
};
export {
  link_preview_default as default
};
//# sourceMappingURL=link-preview-scss.js.map
